<!--
 * @Desc: 师资队伍
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-07 10:23:00
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-teachers">
        <!-- <img
            class="teacher-bg"
            src="../../../public/statics/images/Index/teachers-item-bg2.png"
        /> -->
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/teachers-title.png"
                    />
                </div>
                <div class="title-more" @click="toMore()">
                    了解更多
                    <img
                        class="thu"
                        src="../../../public/statics/images/arr.png"
                    />
                </div>
            </div>
            <!-- 图片切换 -->
            <section class="swiper swiper-teachers">
                <div class="swiper-wrapper" v-if="listData && listData.article">
                    <div class="swiper-slide" v-for="(item,idx) in listData.article" :key="idx" @click="toDetail(item)">
                        <div class="text-info">
                            <div class="text-title">{{ item.keywords }}</div>
                            <p class="text-desc">
                                {{ item.describe }}
                            </p>
                            <div class="info-more">
                                了解更多
                                <img
                                    class="more-thu"
                                    src="../../../public/statics/images/arr.png"
                                />
                            </div>
                        </div>
                        <div class="thu-info">
                            <img
                                class="thu"
                                :src="$adddom(item.thumb)"
                            />
                            <div class="tips">
                                <div class="tip-desc ellipsis3">
                                    {{ item.describe }}
                                </div>
                                <div class="name">{{ item.title }}</div>
                                <!-- <div class="duties-email">
                                    <span>校长</span>xujiaqing@google.com
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="swiper-pagination"></div> -->
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            swiper: "",
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    props:['listData'],
    watch:{
        'listData':function(){
        }
    },
    created: function () {},
    updated: function () {
        let that = this
        this.$nextTick(()=>{
            if (that.swiper) {
                that.swiper.disable()
                that.swiper = ''
            }
            that.swiper = new Swiper(".swiper-teachers", {
                spaceBetween: 50,
                loop: true,
                // autoplay: {
                //     delay: 5000,
                //     stopOnLastSlide: false,
                //     disableOnInteraction: false,
                // },
                on: {
                    slideChangeTransitionStart: function () {
                        // console.log(this.activeIndex);
                        // that.activeIndex = this.activeIndex;
                    },
                    slideChangeTransitionEnd: function () {
                        // console.log(this);
                        // that.activeIndex = this.activeIndex;
                    },
                },
            });
        })
    },
    methods: {
        // 跳转更多
        toMore(){
            // console.log(this.listData.url)
            // console.log(this.listData.id)
            this.$toPath(this.listData.url,{
                active:this.listData.id
            })
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */        
         toDetail(item){
            console.log(item)
            this.$toPath('/NewsDetail?active='+this.listData.id+'&id=' +item.id)
        },
    },
};
</script>

<style scoped>
.page-teachers {
    width: 100%;
    height: 930px;
    background: url(../../../public/statics/images/Index/notice-bg.jpg) no-repeat top center #002140;
    position: relative;
}
.teacher-bg {
    position: absolute;
    top: 218px;
    left: 50%;
    transform: translateX(327px);
}
.page-teachers .container {
    padding-top: 130px;
}
.page-teachers .title-hold .title::after {
    width: 138px;
    height: 28px;
    background: url(../../../public/statics/images/Index/teachers-desc.png);
}
.swiper {
    width: 1200px;
    height: 648px;
    margin-top: 30px;
}
.swiper-slide {
    width: 1200px;
    height: 648px;
    box-sizing: border-box;
    font-size: 18px;
    background: #f3f0ec;

    display: flex;
    justify-content: space-between;
    padding-top: 87px;
    padding-left: 207px;
    padding-right: 78px;

    position: relative;
    background: url(../../../public/statics/images/Index/teachers-item-bg.png)
        no-repeat;
}
.swiper-slide .text-info {
    width: 336px;
    padding-top: 72px;
}
.swiper-slide .text-info .text-title {
    font-size: 24px;
    line-height: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    position: relative;
    display: inline-block;
    padding-right: 60px;
}
.swiper-slide .text-info .text-title::after {
    content: "";
    width: 38px;
    height: 47px;
    position: absolute;
    right: 0px;
    top: -23px;
    background: url(../../../public/statics/images/Index/teachers-item-bg3.jpg)
        no-repeat;
}
.swiper-slide .text-info .text-desc {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 28px;
    color: rgba(51, 51, 51, 1);
    text-align: left;
    vertical-align: top;
    margin-top: 20px;
    margin-bottom: 40px;
}
.swiper-slide .text-info .info-more {
    width: 118px;
    height: 44px;
    background: #1677ff;
    font-size: 14px;
    font-family: AppleSystemUIFont;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.swiper-slide .text-info .info-more .more-thu {
    width: 18px;
    height: 13px;
    margin-left: 13px;
}
.swiper-slide .thu-info {
    width: 398px;
    height: 500px;
    background: #b9edff;
    position: relative;
}
.swiper-slide .thu-info .thu {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.swiper-slide .thu-info .tips {
    position: absolute;
    right: 0;
    bottom: 0;
    background: url(../../../public/statics/images/Index/teachers-item-bg4.jpg)
        no-repeat;
    width: 281px;
    height: 208px;
    box-shadow: 0px 12px 24px 0px rgba(62, 51, 51, 0.08);
    padding: 26px 20px;
    padding-bottom: 20px;
}
.swiper-slide .thu-info .tips .tip-desc{
    font-size: 16px;
    font-weight: 400;
    letter-spacing: -0.2px;
    line-height: 28px;
    color: rgba(102, 102, 102, 1);
    height: 84px;
}
.swiper-slide .thu-info .tips .name{
    font-size: 24px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #333333;
margin-top: 30px;
margin-bottom: 6px;
}
.swiper-slide .thu-info .tips .duties-email{
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #E22F24;
}
.swiper-slide .thu-info .tips .duties-email span{
    font-weight: 500;
    color: #666666;
    margin-right: 10px;
}
</style>
